<template>
<div>
    <h1 class="page-title">Miscellaneous</h1>
    <notifications position="bottom right" group="items" />

    <div v-for="item in miscellaneous" :key="item.item_id">
        {{ item.item_name }} - {{ item.item_event_type.event_type_name}} - {{ item.item_status }}
        <v-btn @click="updateItem(item, 'PU')">Set status to Published</v-btn>
        <v-btn @click="updateItem(item, 'RE')">Set status to Rejected</v-btn>

    </div>

</div>
</template>

<script>
import {
    mapState
} from "vuex";

export default {
    methods: {
        async updateItem(item, status) {
            let action = 'editItem';
            if (item.item_event_type.event_type_name == 'game') {
                action = 'editGame'
            }
            item.item_status = status;
            item.item_event_type = item.item_event_type.id
            await this.$store
                .dispatch(action, item)
                .then((data) => {
                        if (data.success) {
                            this.$notify({
                                group: 'items',
                                title: "Updated!",
                                type: 'success',
                                text: 'The item is updated.'
                            })
                            // Remove item from miscellaneousDraft.
                            this.$store.dispatch("getMiscellaneousDraft");
                        } else {

                            this.$notify({
                                group: 'items',
                                title: "error",
                                type: 'error',
                                text: 'Something went wrong.'
                            })
                        }
                    }

                );
        }
    },
    computed: mapState({
        ownProfile: (state) => state.profiles.ownProfile,
        miscellaneous: (state) => state.items.miscellaneousDraft,
    }),
    mounted() {
        this.$store.dispatch("getMiscellaneousDraft");
    },
};
</script>
